import { ClassArea } from '@core/models/class-area.models';
import { EntityState } from '@ngrx/entity';

export interface AreaState extends EntityState<ClassArea> {
  isLoaded: boolean;
  isLoading: boolean;
  selected: string;
}
